import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ruRU } from '@material-ui/core/locale';
import { useMediaQuery, Box } from '@material-ui/core';
import { useQuery } from 'react-query';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import ability from 'permissions/ability';
import { AbilityContext } from 'permissions/Can';
import { getToken, getValidatedRole, removeCredentials, rolesRedirect, setRoles } from 'common/utils/roles';
import { ERouteUrl, routes } from 'router/config';
import Route from 'router/Router';
import { OverlayLoader } from 'components/ui/OverayLoader';
import { Header } from 'components/layout/Header';
import { getCurrentUser } from 'features/service/user-controller/api';
import { globalStyles } from 'style/globalStyle';
import { themeOptions } from 'style/themeOptions';
import { EQueryConst } from 'features/service/config';
import { versionIntercept } from 'common/version/versionIntercept';
import { allMenuIsHidden, isPrintPage } from 'config';
import { initializeAmplitude } from 'common/amplitude/amplitude';
import { createPortal } from 'react-dom';

/** Тема для MaterialUI */
export const theme = createMuiTheme(themeOptions, ruRU);

export const App = () => {
  /** Устанавливаем глобальные стили */
  globalStyles();
  const { pathname } = useLocation();
  const token = getToken();
  const matchesTablet = useMediaQuery(theme.breakpoints.down('sm'));

  /** Запрашиваем данные для юзера */
  const { data: currentUser, refetch, status } = useQuery(EQueryConst.CURRENT_USER, getCurrentUser, {
    // enabled: false,
    onError: error => {
      if (error) {
        return null;
      }
    },
  });

  /** Если нет токена то сразу сбрасываем креды */
  if (!token) removeCredentials();

  if (token && status === 'idle') refetch();

  /** Далее нам надо проверить, есть ли такая роль у нас в системе. */
  if (currentUser) {
    setRoles(currentUser.roles);
    const currentRole = getValidatedRole(currentUser.roles);
    /** Если роль для нас неизвестна, то сбрасываем креды */
    !currentRole && removeCredentials();
  }
  /** Пока запрос на пользователя не отработал, мы не знаем что показывать. Когда пришла ошибка или success у нас либо есть роль либо нет */
  if (token && (status === 'loading' || status === 'idle')) return <OverlayLoader />;

  /** Делаем редиректы для разных ролей на стартовые страницы */
  if (token && currentUser && pathname === ERouteUrl.LOGIN) {
    rolesRedirect(currentUser);
  }

  initializeAmplitude();
  // ИнитВерсии
  // if (currentUser) versionIntercept();

  return (
    <AbilityContext.Provider value={ability(currentUser)}>
      <ThemeProvider theme={theme}>
        <Box
          display='grid'
          gridTemplateColumns={!matchesTablet ? 'auto minmax(0, 1fr)' : 'minmax(0, 1fr)'}
          bgcolor='#F5F6F8'
        >
          {currentUser && !isPrintPage(pathname) && allMenuIsHidden(pathname) && (
            <>
              <Header user={currentUser} />
            </>
          )}
          <Route routes={routes} />
          {/* <Version /> */}
        </Box>
      </ThemeProvider>
      {createPortal(<ToastContainer />, document.body)}
    </AbilityContext.Provider>
  );
};
